import React, {Component} from "react";
import Head from "../../components/Head";
import {withTranslate} from "react-redux-multilingual";
import globalMiddleware from "../../hocs/globalMiddleware";
import DoctorsPage from "../../components/doctors/DoctorsPage"
import {setCurrentRoute} from "../../store/actions/globalActions";
import {connect} from "react-redux";


class FavouriteDoctors extends Component {
    componentDidMount() {
        window.scrollTo(0, 0);
        this.props.setCurrentRoute(window.location.href);

    }

    state = {
        scroll: true,
    };

    // fetchPage = (page, e) => {
    //     e.preventDefault();
    //     this.props.requestDoctorsPage(page);
    // };


    render() {
        const history = [
            {
                page: this.props.translate("home"),
                to: "/"
            }
        ];


        return (
            <div>
                <Head title={this.props.translate("doctors")} history={history}/>
                <DoctorsPage specialtyString="" language={this.props.language} mobileMenuIsShown={this.props.mobileMenuIsShown} isFavourite={true}/>
            </div>
        )
    }


}

const mapStateToProps = (state) => {
    return {}
};

const mapDispatchToProps = (dispatch) => {
    return {
        setCurrentRoute: (route) => dispatch(setCurrentRoute(route)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(globalMiddleware(withTranslate(FavouriteDoctors)));